import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Modal from 'shared/components/Modal';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import withSliderLogic from 'shared/hocs/withSliderLogic';
import { urlReplace } from 'shared/modules';
import carImg from './car.svg';
import MainImage from './MainImage/MainImage';
import s from './AdvertPhotos.css';

class AdvertPhotos extends React.Component {
  static propTypes = {
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
      }),
    ),
    setRatioImage: PropTypes.func.isRequired,
    setRatioAlbum: PropTypes.func.isRequired,
    defaultImg: PropTypes.string,
    //
    index: PropTypes.number,
    id: PropTypes.number,
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    // methods
    setFullscreenImage: PropTypes.func.isRequired,
    setPrevId: PropTypes.func.isRequired,
    setNextId: PropTypes.func.isRequired,
    closeSlider: PropTypes.func.isRequired,
    decrementIndex: PropTypes.func.isRequired,
    incrementIndex: PropTypes.func.isRequired,
    setPreviewImage: PropTypes.func.isRequired,
    setImageId: PropTypes.func.isRequired,
    isDealerInfoPage: PropTypes.bool,
    isDealerPage: PropTypes.bool,
    alt: PropTypes.string,
  };
  static defaultProps = {
    isDealerInfoPage: false,
    isDealerPage: false,
    photos: [],
    index: 0,
    id: null,
    defaultImg: carImg,
    alt: '',
  };

  state = {
    index: 0,
    id: null,
    left: 0,
    fullScreenSlideWidth: 800,
    photos: this.props.setRatioAlbum(this.props.photos, 490),
  };

  onSetPrevId = e => {
    e.stopPropagation();
    this.props.setPrevId();
  };

  onSetNextId = e => {
    e.stopPropagation();
    this.props.setNextId();
  };

  renderEmptyPhotos = () =>
    <div className={s.root}>
      <div className={s.empty}>
        <img src={this.props.defaultImg} alt="" />
      </div>
    </div>;

  render() {
    const { photos } = this.state;
    const { id, index, left, alt, setRatioImage, isDealerPage, isDealerInfoPage } = this.props;

    if (!photos || !photos.length) {
      return this.renderEmptyPhotos();
    }

    const rootImage = photos && photos[index];

    const sliderImages = this.props.photos.map(({ image, ...rest }) => ({
      ...rest,
      image: setRatioImage(image, 960, null),
    }));
    const sliderImage = sliderImages && sliderImages.find(photo => photo.id === id);

    return (
      <div className={s.root}>
        <div className={s.main}>
          {photos.length > 1 &&
            <i className={`fa fa-angle-left ${s.rootPrev}`} onClick={this.props.decrementIndex} data-lens-event="showPhoto" />}
          <MainImage
            mainImage={rootImage}
            sliderClassName={cx(s.imgRoot, { [s.dealerPageImg]: isDealerPage }, { [s.dealerPageImg]: isDealerInfoPage })}
            onClick={this.props.setFullscreenImage}
            appear={s.animAppear}
            appearActive={s.animAppearActive}
          />
          {photos.length > 1 &&
            <i className={`fa fa-angle-right ${s.rootNext}`} onClick={this.props.incrementIndex} data-lens-event="showPhoto" />}
        </div>
        {isDealerInfoPage && <div id="main-block" />}

        <div className={s.gallery}>
          {photos.length > 1 &&
            !isDealerInfoPage &&
            photos.map((item, i) => (
              <div
                className={cx({ [s.active]: id === item.id }, s.thumb)}
                key={item.id}
                style={{
                  display: `${i >= 12 ? 'none' : undefined}`,
                }}
              >
                {i === 12 - 1 && (
                  <span className={s.lastImg}>
                    {' '}
                    <FormattedMessage id="Еще" /> {` ${photos.length - (12 - 1)}`}
                  </span>
                )}
                <img
                  src={(item && item.image) || item}
                  id={item.id}
                  className={cx({ [s.active]: index === i }, s.img)}
                  onMouseOver={() => this.props.setPreviewImage(i)}
                  onClick={() => this.props.setImageId(item.id)}
                  alt={`${alt} - фото ${i + 1}`}
                  title={`${alt} - фото ${i + 1}`}
                  data-lens-event="showPhoto"
                />
              </div>
            ))}
        </div>

        {id &&
          <Modal>
            <div className={s.fullscreenSlider} onClick={this.props.closeSlider}>
              {sliderImages.length > 1 &&
                <i className={`fa fa-angle-left ${s.sliderPrev}`} onClick={this.onSetPrevId} />}
              <MainImage
                mainImage={sliderImage}
                sliderClassName={s.sliderMainImg}
                onClick={this.onSetNextId}
                appear={s.animAppear}
                appearActive={s.animAppearActive}
              />

              {sliderImages.length > 1 &&
                <i className={`fa fa-angle-right ${s.sliderNext}`} onClick={this.onSetNextId} data-lens-event="showPhoto" />}
              <i className={s.sliderClose} onClick={this.props.closeSlider} data-lens-event="showPhoto" />

              <div className={s.sliderGalleryContainer}>
                <div
                  className={s.sliderGallery}
                  style={{
                    transform: `translateX(-${left}px)`,
                    width: `${110 * sliderImages.length}px`,
                  }}
                >
                  {sliderImages.length > 1 &&
                    sliderImages.map(photo =>
                      <div
                        style={{
                          flex: `1 0 100px`,
                          height: `70px`,
                          margin: `10px 5px`,
                          maxWidth: '100px',
                        }}
                        className={cx({ [s.active]: id === photo.id }, s.sliderThumb)}
                        key={photo.id}
                      >
                        <span
                          id={photo.id}
                          className={s.sliderImg}
                          onMouseOver={this.props.setFullscreenImage}
                          onClick={e => e.stopPropagation()}
                          style={{
                            backgroundImage: `url(${urlReplace((photo && photo.image) || photo)})`,
                          }}
                          data-lens-event="showPhoto"
                        />
                      </div>,
                    )}
                </div>
              </div>
            </div>
          </Modal>}
      </div>
    );
  }
}

export default withStyles(s)(withPixelRatio(withSliderLogic(AdvertPhotos)));



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertPhotos/AdvertPhotos.js